// extracted by mini-css-extract-plugin
module.exports = {"link":"generalLinkStyles_link__3J4zo","activeItem":"generalLinkStyles_activeItem__1u0Wh"};